import {getRequest} from '@/utils/api'


export function getRouters() {
  return getRequest("/getRouters")
}





// WEBPACK FOOTER //
// ./src/api/sys/resource.js